// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__L6MDY","rounded":"Placeholder_rounded__4_BV5"};